export default __webpack_public_path__ + "static/media/dashboard-investor-list-icon.2c5ff585.svg";